import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./AppDialog.css";

export default function AppDialog({
  open,
  onClose,
  title,
  subtitle,
  children,
  actions,
  maxWidth = "sm",
  fullWidth = true,
  disableBackdropClose = false,
  disableEscapeClose = false,
  showCloseIcon = true,
  classes = {},
}) {
  const handleClose = (event, reason) => {
    if (disableBackdropClose && reason === "backdropClick") return;
    if (disableEscapeClose && reason === "escapeKeyDown") return;
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      PaperProps={{
        className: `appDialogPaper ${classes.paper || ""}`.trim(),
      }}
    >
      {(title || showCloseIcon) && (
        <DialogTitle className={`appDialogTitle ${classes.title || ""}`.trim()}>
          <div className="appDialogTitleRow">
            <div className="appDialogTitleText">
              {typeof title === "string" ? (
                <Typography variant="h5">{title}</Typography>
              ) : (
                title
              )}

              {subtitle ? (
                <Typography
                  variant="body2"
                  className="appDialogSubtitle"
                  component="p"
                >
                  {subtitle}
                </Typography>
              ) : null}
            </div>

            {showCloseIcon && (
              <IconButton
                aria-label="close"
                onClick={onClose}
                size="small"
                className="appDialogCloseBtn"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </div>
        </DialogTitle>
      )}

      <DialogContent
        dividers
        className={`appDialogContent ${classes.content || ""}`.trim()}
      >
        {children}
      </DialogContent>

      {actions ? (
        <DialogActions
          className={`appDialogActions ${classes.actions || ""}`.trim()}
        >
          {actions}
        </DialogActions>
      ) : null}
    </Dialog>
  );
}
